export const disableFutureDate = () => {
  return new Date().toISOString().slice(0, 10);
};
